import {
  Linking,
  Pressable,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalise";

import { Colors } from "colors";
import { FONTS_SIZES } from "fonts";
import ImageView from "../../../src/image";

import { Images } from "assets";
import Markdown from "react-native-markdown-display";
import React from "react";
import VText from "components/VText";
import { getFormatedCurrency } from "utils/common";
import moment from "moment";
import { router } from "expo-router";

const OrderStatusCard = ({
  productDetails,
  isPaymentSuccess,
  inStore = false,
  preorder = {},
  gender,
}) => {
  return (
    <View style={styles.productCard}>
      {preorder?.showPreorder && (
        <View>
          <View
            style={{
              paddingHorizontal: 8,
              paddingVertical: 6,
              borderWidth: 1,
              borderColor: "#21242799",
              borderRadius: 2,
              backgroundColor: "#FFFFFF",
              alignSelf: "flex-start",
              marginBottom: 8,
            }}
          >
            <VText
              style={{
                fontSize: 8,
                fontWeight: "550",
                letterSpacing: "3%",
                color: "#21242799",
              }}
            >
              PRE ORDER
            </VText>
          </View>
          {preorder?.preorderDateMessage && (
            <View
              style={{
                marginBottom: 16,
              }}
            >
              <Markdown
                style={{
                  fontSize: 13,
                  fontWeight: "350",
                  color: "#21242799",
                }}
              >
                {preorder?.preorderDateMessage}
              </Markdown>
            </View>
          )}
        </View>
      )}
      {isPaymentSuccess ? (
        <>
          {!preorder?.showPreorder && (
            <View
              style={[
                styles.rowAlignCenter,
                {
                  paddingBottom: spV(20),
                },
              ]}
            >
              {!inStore && (
                <VText
                  style={[
                    styles.text,
                    {
                      fontSize: fp(16),
                    },
                  ]}
                >
                  {"Delivery By "}
                  <VText style={styles.boldText}>
                    {moment(productDetails?.deliveryDate).format(
                      "MMMM DD, YYYY"
                    )}
                  </VText>
                </VText>
              )}
            </View>
          )}
        </>
      ) : null}
      <View
        style={[
          styles.flexRow,
          {
            paddingBottom: spV(28),
            borderBottomWidth: 1,
            borderColor: "rgba(33, 36, 39, 0.3)",
          },
        ]}
      >
        <Pressable
          onPress={() => {
            router.push(
              `${gender == "men" ? "/men" : ""}/product/${productDetails?.id}/${
                productDetails?.brandName
              }/${productDetails?.productName}`?.replaceAll(" ", "-")
            );
          }}
        >
          <ImageView
            source={{
              uri: productDetails?.imageUrls?.[0],
              priority: ImageView.priority.high,
            }}
            resizeMode={ImageView.resizeMode.contain}
            style={styles.image}
          />
        </Pressable>

        <View
          style={{
            paddingLeft: spH(10),
            flex: 1,
          }}
        >
          <VText
            style={{
              fontSize: fp(14),
              fontWeight: "550",
              lineHeight: "140%",
              paddingBottom: spV(4),
            }}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {productDetails?.brandName?.toUpperCase()}
          </VText>
          <VText
            style={{
              fontSize: fp(14),
              fontWeight: "350",
              lineHeight: "140%",
              marginBottom: spV(4),
              width: "100%",
            }}
            numberOfLines={2}
          >
            {productDetails?.productName}
          </VText>
          <VText
            style={[
              {
                fontSize: fp(14),
                fontWeight: "550",
                lineHeight: "140%",
                marginBottom: spH(9),
              },
            ]}
          >{`$${getFormatedCurrency(productDetails?.productPrice)}`}</VText>
          {productDetails?.returnObject?.url !== "" ? (
            <TouchableOpacity
              onPress={() => {
                Linking.openURL(productDetails?.returnObject?.url);
              }}
              style={{
                width: spH(96),
                height: spV(32),
                borderRadius: 4,
                flexDirection: "row",
                backgroundColor: "rgba(247, 247, 247, 1)",
                justifyContent: "space-between",
                alignItems: "center",
                paddingHorizontal: 8,
                marginBottom: 9,
              }}
            >
              <VText
                style={{
                  fontSize: fp(12),
                  color: Colors.black60,
                  fontWeight: "350",
                }}
              >
                {"Return Policy"}
              </VText>
              <ImageView
                source={Images.rightArrow}
                style={{ width: 13, height: 14, tintColor: Colors.black30 }}
              />
            </TouchableOpacity>
          ) : (
            <View
              style={{
                width: "auto",
                minHeight: spV(32),
                borderRadius: 8,
                flexDirection: "row",
                backgroundColor: "rgba(247, 247, 247, 1)",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 9,
                paddingHorizontal: 12,
                alignSelf: "flex-start",
                marginRight: 10,
                paddingVertical: 6,
              }}
            >
              <VText style={styles.returnText}>
                {`Return policy: ${productDetails?.returnObject?.text}`}
              </VText>
            </View>
          )}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {productDetails?.size && (
              <VText
                style={{
                  fontSize: fp(14),
                  fontWeight: "350",
                }}
              >{`Size: ${productDetails?.size}`}</VText>
            )}
            <VText
              style={[
                {
                  paddingLeft: spH(16),
                  fontSize: fp(14),
                  fontWeight: "350",
                },
              ]}
            >{`Quantity: ${productDetails?.quantity}`}</VText>
          </View>
        </View>
      </View>
      {preorder?.preorderDeliveryMessage && (
        <View
          style={{
            marginBottom: 16,
          }}
        >
          <Markdown
            style={{
              fontSize: 13,
              fontWeight: "350",
              color: "#21242799",
            }}
          >
            {preorder?.preorderDeliveryMessage}
          </Markdown>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  flexRow: {
    flexDirection: "row",
  },
  rowAlignCenter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  container: {
    borderRadius: 8,
    marginHorizontal: 16,
  },
  productCard: {
    marginTop: spV(5),
    marginBottom: spV(28),
  },
  image: {
    width: wp(111),
    height: hp(148),
  },
  dotStyle: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginHorizontal: 0,
    backgroundColor: "rgba(0, 0, 0, 0.92)",
  },
  subitleStyle: {
    color: Colors.black60,
    marginTop: 4,
    marginBottom: 16,
  },
  titleStyle: {
    marginTop: 4,
  },
  text: {
    color: Colors.black0,
    fontWeight: "350",
  },
  boldText: {
    color: Colors.black,
    fontSize: fp(16),
    fontWeight: "550",
    display: "inline",
  },
  imgIcon: {
    height: 25,
    width: 25,
  },
});

export default OrderStatusCard;
